import RegistrationForm from 'components/organisms/RegistrationForm/RegistrationForm';
import React from 'react';

export interface Props {}

const SignUp: React.FC<Props> = (props) => {
  return <RegistrationForm {...props} />;
};
export default SignUp;
